import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";

import {
    MyDate,
    myAxios,
    outsidePotDefaultEmptyData,
    standbyWeeks,
    weeknum,
} from "src/components/common/functions";

const title = "PlannedOT";

export async function plannedOTLoader({ params }: LoaderFunctionArgs) {
    const selectedWeek = standbyWeeks.includes(params.week ?? "")
        ? (params.week as string)
        : (standbyWeeks.includes(weeknum(new MyDate().s())) ? weeknum(new MyDate().s()) : (standbyWeeks[0] ?? ""));

    const formData = new FormData();
    formData.append("week", selectedWeek);
    formData.append("action", "Read");

    const res = await myAxios({ fileName: "outside/pot/pot.php", formData });
    if (!res) throw redirect("..");
    const divisionRes = await myAxios({ fileName: "outside/divisions/readDivisions.php" });
    if (!divisionRes) throw redirect("..");

    return {
        week: selectedWeek,
        form: JSON.parse(res.data?.[selectedWeek] || outsidePotDefaultEmptyData),
        divisions: divisionRes.data,
    };
}

export async function plannedOTAction({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    const currentWeek = String(formData.get("currentWeek") ?? "");

    const res = await myAxios({ fileName: "outside/pot/pot.php", formData });
    if (!res) throw redirect("..");

    return redirect(`/${title}/${currentWeek}`);
}
